import styled, {css} from 'styled-components'

export default styled.img`
  max-width: 100%;
  display: block; // to remove unwanted whitespace below that is automatic from inline for descenders

  ${props => props.maxWidth && css`
    max-width: ${props.maxWidth};
  `}
  ${props => props.maxHeight && css`
    max-height: ${props.maxHeight};
  `}

  ${props => props.minWidth && css`
    min-width: ${props.minWidth};
  `}
  ${props => props.minHeight && css`
    min-height: ${props.minHeight};
  `}

  ${props => props.cover && css`
    position: absolute;
    min-width: 100%;
    min-height: 100%;
    object-fit: cover;
  `}

  ${props => props.contain && css`
    position: absolute;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  `}

  // transform: scaleY(1);
  top: 0;
  transition: all 1s;
  ${props => props.animate && css`
    &:hover {
      // transform: scaleY(1.5);
    }
  `}



  cursor: crosshair;
`



// WEBPACK FOOTER //
// ./src/shared/Img.js